import { Checkbox, CheckboxProps } from 'antd';
import { uiStore } from 'stores/root_store';

const CustomCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      className={
        uiStore.theme.name +
        ' [&_.ant-checkbox-checked_.ant-checkbox-inner]:!bg-primary [&_.ant-checkbox-inner]:!text-primary ' +
        props.className
      }
    >
      {props.children}
    </Checkbox>
  );
};

export default CustomCheckbox;
